import { useState } from 'react';
import cx from 'classnames';
import { useEffect } from 'react';
import { start } from 'repl';

type PaginationProps = {
    totalRecordCount: number;
    recordLimit: number;
    parentCurrentPage: number;
    changeHandler: ((pageNumber: number) => void);
};

export const Pagination = ({
    totalRecordCount,
    recordLimit,
    parentCurrentPage,
    changeHandler,
}: PaginationProps) => {
    const pageCount = Math.ceil(totalRecordCount / recordLimit);
    const [currentPage, setCurrentPage] = useState(parentCurrentPage ?? 1);
    const pagesLimit = 17;

    const getPaginationArray = () => {
        let startingPage = 1; //first option in the pages 
        let endingPage = (pageCount <= pagesLimit) ? pageCount : pagesLimit; //last option in the pages
        let endOfPagesRange = (pageCount - pagesLimit) + 1;
        let middleOfPagesOptions = Math.round(pagesLimit / 2);

        //this will determine if there are more pages than fits in the options
        if (pageCount > pagesLimit && //there are more page than allowed to display
            currentPage > middleOfPagesOptions //the current page is past the halfway point of the page options
        ) {
            //if the current page is towards the end of the options
            if (currentPage >= endOfPagesRange) {
                startingPage = endOfPagesRange;
            } else {
                //calcuate where to start so the selected page is in the middle
                startingPage = (currentPage - middleOfPagesOptions);
            }

        }

        //build out the pages, will never be greater than pagesLimit
        let pages: number[] = [];
        for (var i = 0; i < endingPage; i++) {
            pages.push(startingPage);
            startingPage++;
        }

        return pages;
    };
    const changePage = (event: any) => {
        const pageNumber = Number(event?.target?.textContent);
        setCurrentPage(pageNumber);
    }
    const goToPreviousPage = () => {
        setCurrentPage((page) => page - 1);
    }
    const goToNextPage = () => {
        setCurrentPage((page) => page + 1);
    }

    useEffect(() => {
        changeHandler(currentPage);
    }, [currentPage, changeHandler]);

    return (
        <div className='pagination flex items-center justify-center m-auto'>
            {/* previous button */}
            <button
                onClick={goToPreviousPage}
                disabled={currentPage === 1}
                className={
                    cx(
                        'prev text-xl bg-gray-100 text-ptsblue-normal font-bold border-1 border-solid border-gray-300 rounded-lg',
                        'hover:bg-ptsblue-normal hover:text-gray-100'
                    )
                }
            >prev
            </button>

            {/* page number buttons */}
            {getPaginationArray().map((item, index) => (
                <button
                    key={index}
                    onClick={changePage}
                    disabled={item > pageCount}
                    className={
                        cx(
                            'paginationItem m-1 h-12 w-12 p-1 text-xl font-bold border-1 border-solid border-gray-300 rounded-full',
                            {
                                'bg-ptsgreen-dark text-white hover:bg-ptsblue-normal hover:text-white': currentPage === item,
                                'bg-gray-100 text-ptsblue-normal hover:bg-ptsblue-normal hover:enabled:bg-ptsblue-normal hover:text-gray-100': currentPage !== item,
                            }
                        )
                    }
                >
                    <span>{item}</span>
                </button>
            ))}

            {/* next button */}
            <button
                onClick={goToNextPage}
                disabled={currentPage === pageCount}
                className={
                    cx(
                        'next text-xl bg-gray-100 text-ptsblue-normal font-bold border-1 border-solid border-gray-300 rounded-lg',
                        'hover:bg-ptsblue-normal hover:text-gray-100'
                    )
                }
            >next
            </button>
        </div>
    );
};